<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol v-if="!loading_class">
             <label > Class Name </label>
            <b-form-select v-if="disable_select === 0" v-model="form.class_id" :options= "options_new" :disabled="disable_select === 1"></b-form-select>
            <b-form-select v-if="disable_select === 1" v-model="form.class_id" :options= "options_edit" :disabled="disable_select === 1"></b-form-select>
            
          </CCol>
          <CCol v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CCol> 
          </CRow>
          <label class="mt-2"> Start Date </label>
             <CRow >
              <CCol >
                 <CInput v-model="form.start_date" description="Kolom dapat diisi dengan format [hari/bulan/tahun]" type="date"  />
              </CCol>
            </CRow>
            <label > End Date </label>
             <CRow >
              <CCol >
               <CInput v-model="form.end_date" description="Kolom dapat diisi dengan format [hari/bulan/tahun]" type="date"  />
              
              </CCol>
            </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="join_class()"  variant="outline" color="info">Join</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update_class()"  variant="outline" color="info">Edit</CButton>
     
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import general from '@/services/generalclass';
import attendance from '@/services/classattendance';

import moment from 'moment';

export default {
name: 'icaremodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    disable_select: 0,
    array_id_getclass:[],
    form:{
      uuid:'',
      name:'',
      class_id:'',
      id:'',
      start_date:'',
      end_date:''
    },
    options:[],
    options_new:[],
    options_edit:[],
    loading_class: false,
   
    }
  },
  
  mounted(){
    
  },
  created () {
      var self = this; 
      EventBus.$on('OPEN_MODAL_MEMBER_CLASS', (params) => {
      if(params.data){

        // self.loading_class = true;
        this.get_general_class()
        // self.array_id_getclass = ''
        // self.get_general_class()

      attendance.getClass(this.$route.query.Pud)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.disable_select = 1;
          for(let i = 0; i <= res.data.length-1; i++){
            //this.array_id_getclass.push(res.data[i].general_class_id);
            // console.log(params.data)
            // console.log(res.data[i].id)
            if(params.data === res.data[i].id){
              // console.log("success")
                self.form.id = res.data[i].id
                self.form.class_id = res.data[i].general_class_id
                self.form.start_date = res.data[i].start_date
                self.form.end_date = res.data[i].end_date
            }
            // this.classname_id.push(res.data[i].id);
            // this.classname_name.push(res.data[i].name);
          }

      // self.form.uuid = res.data.uuid;
      // self.form.name = res.data.name;
      // self.form.icare_id = res.data.icare_id;
      self.loading_class = false;
       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        //self.loading_class = true;
        this.get_general_class()
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.disable_select = 0;
        self.form.uuid = "";
        self.form.name = "";
        self.form.class_id = "";
        self.form.start_date = "";
        self.form.end_date = "";
        //self.loading_class = false;
        //self.options = []

        // attendance.getClass(this.$route.query.Pud)
        // .then(res => {
        //     for(let i = 0; i <= res.data.length-1; i++){
        //       self.array_id_getclass.push(res.data[i].general_class_id);
        //     }
        //   })
        // self.get_general_class()
      }
    });   
  },
  methods: {
    get_general_class(){
      this.loading_class = true;
      console.log("a1")
      attendance.getClass(this.$route.query.Pud)
      .then(res => {
           for(let i = 0; i <= res.data.length-1; i++){
            this.array_id_getclass.push(res.data[i].general_class_id);
          }
        }).catch((er) =>{
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
          console.log("b1")
          this.options = []
          this.options_new = []
          this.options_edit = []
          general.getGeneral()
          .then(res => {
            for (let i=0; i <= res.data.length-1; i++){
              //alert
              if(this.array_id_getclass.includes(res.data[i].id)){
                //this.options.push({text: res.data[i].name, value:res.data[i].id})  
                this.options_edit.push({text: res.data[i].name, value:res.data[i].id})    
              }else{
                this.options.push({text: res.data[i].name, value:res.data[i].id})
                this.options_new.push({text: res.data[i].name, value:res.data[i].id})
                this.options_edit.push({text: res.data[i].name, value:res.data[i].id}) 
              }
            }
          }).catch((er) =>{
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
          console.log("c1")
    this.loading_class = false;      
    },
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    join_class(){
          this.form.start_date  = moment(this.form.start_date).format('DD/MM/YYYY')
          if(this.form.end_date === ''){
            //this.form.end_date = ''
          }else{
            this.form.end_date  = moment(this.form.end_date).format('DD/MM/YYYY')
          }          
          
          console.log(this.form)
          attendance.join_class(this.$route.query.Pud, this.form)
          .then(res => {
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.show = false;
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },
    update_class(){
          this.form.start_date  = moment(this.form.start_date).format('DD/MM/YYYY')
          if(this.form.end_date === ''){
            //this.form.end_date = ''
          }else{
            this.form.end_date  = moment(this.form.end_date).format('DD/MM/YYYY')
          }          
          
          console.log(this.form)
          attendance.update_class(this.$route.query.Pud,this.form.id, this.form)
          .then(res => {
            EventBus.$emit('PAGE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.show = false;
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
      },    
   
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>